import ORDER_LIST from "./order";

export default ORDER_LIST;
